import React from 'react'

function MenuSpacer({extraSpace}) {
  return (
    <div style={{"marginBottom" : `${extraSpace ? '150px' : '110px'}`}}></div>
  )
}

export default MenuSpacer